module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_04-8245307a9b659be265308c1aef868422.jpg";